import React, { useEffect, useState } from "react";
import AppLayout from "../components/AppLayout";
import { api } from "../lib/api";
import BrainTypeView from "../components/BrainTypeView";

export default function CoacheeBrainTypeProfilePage() {
  const [me, setMe] = useState(null);
  const [coachee, setCoachee] = useState(null);
  const [result, setResult] = useState(null);
  const [calendlyEmbed, setCalendlyEmbed] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const { data: u } = await api.get("/auth/me");
        setMe(u);
        const { data: list } = await api.get("/coachees");
        const own = list.find((p) => p.user_id === u.id) || null;
        setCoachee(own);
        if (own) {
          try {
            const { data: r } = await api.get(`/survey/result/${own.id}`);
            setResult(r);
          } catch (err) {
            if (err?.response?.status !== 404) {
              console.warn("Survey result fetch failed:", err?.message || err);
            }
          }
          try {
            const { data: c } = await api.get(`/coachees/${own.id}/job-coach`);
            if (c?.calendly_embed) setCalendlyEmbed(c.calendly_embed);
          } catch (err) {
            console.warn("Work coach Calendly fetch failed (non-fatal):", err?.message || err);
          }
        }
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <AppLayout
      title="Mijn breintype"
      breadcrumbs={[{ label: "Profielen", to: "/profielen" }, { label: "Mijn breintype" }]}
    >
      {loading || !me ? (
        <div className="text-zinc-500">Laden...</div>
      ) : (
        <BrainTypeView coachee={coachee} surveyResult={result} isOwn={true} calendlyEmbed={calendlyEmbed} />
      )}
    </AppLayout>
  );
}
